import { render, staticRenderFns } from "./DashboardProjectDetailModal.vue?vue&type=template&id=4d7368ab&"
import script from "./DashboardProjectDetailModal.vue?vue&type=script&lang=js&"
export * from "./DashboardProjectDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports